import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority"
import { Loader2, ChevronRight, ChevronLeft, RefreshCw, Eye, Trash2 } from "lucide-react"
import { cn } from "@/components/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow-xs hover:bg-primary/90",
        destructive: "bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
        outline: "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
        secondary: "bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
        link: "text-primary underline-offset-4 hover:underline",
        loading: "bg-primary text-primary-foreground opacity-60 cursor-wait",
        "right-icon": "border border-input hover:bg-accent p-2", 
        "left-icon": "border border-input hover:bg-accent p-2",
        refresh: "bg-blue-600 text-white hover:bg-blue-700 p-2 px-4 rounded-md",
        show: "hover:bg-blue-50 text-blue-600",
        trash: "hover:bg-red-50 text-red-600",
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

function Button({
  className,
  variant,
  size,
  loading = false,  
  asChild = false,
  children,
  ...props
}) {
  const Comp = asChild ? Slot : "button"

  
  let resolvedChildren = children
  if (variant === "right-icon") {
    resolvedChildren = <ChevronRight />
  }
  
  else if (variant === "left-icon") {
    resolvedChildren = <ChevronLeft />
  }
  else if (variant === "refresh") {
    resolvedChildren = (
      <>
        <RefreshCw className="mr-1" size={16} />
        Güncelle
      </>
    );
  }
  else if (variant === "show") {
    resolvedChildren = <Eye className="h-4 w-4" />
  }
  else if (variant === "trash") {
    resolvedChildren = <Trash2 className="h-4 w-4" />
  }

  return (
    <Comp
      data-slot="button"
      className={cn(buttonVariants({ variant, size, className, ...(loading && { variant: "loading" }) }))}
      disabled={loading} 
      {...props}
    >
      {loading ? (
        <>
          <Loader2 className="animate-spin h-4 w-4" /> {}
          Lütfen Bekleyin
        </>
      ) : (
        resolvedChildren 
      )}
    </Comp>
  )
}

export { Button, buttonVariants }